module.exports = __webpack_public_path__ + "static/img/icon_02.e6799fce.svg";